'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import { cn } from '@/lib/utils';
export interface SmsOtpInputProps {
  value: string;
  onChange: (code: string) => void;
  onComplete?: (code: string) => void;
  /** Number of digits in the OTP. Defaults to 4 (SMS). Email-OTP uses 6. */
  length?: number;
  /** When true (default), `onComplete` fires automatically when the value reaches `length`. */
  autoSubmit?: boolean;
  disabled?: boolean;
  'aria-invalid'?: boolean;
  'aria-label'?: string;
  className?: string;
  id?: string;
}
const DEFAULT_OTP_LENGTH = 4;

/**
 * Numeric OTP input (4 digits by default, configurable via `length`). Wraps
 * shadcn `InputOTP` with a `REGEXP_ONLY_DIGITS` pattern and forwards the ref
 * onto the underlying `<input>` so parents can focus the field programmatically
 * (e.g. on step transition or error).
 */
export const SmsOtpInput = React.forwardRef<HTMLInputElement, SmsOtpInputProps>(function SmsOtpInput(t0, ref) {
  const $ = _c(23);
  const {
    value,
    onChange,
    onComplete,
    length: t1,
    autoSubmit: t2,
    disabled,
    "aria-invalid": ariaInvalid,
    "aria-label": t3,
    className,
    id
  } = t0;
  const length = t1 === undefined ? DEFAULT_OTP_LENGTH : t1;
  const autoSubmit = t2 === undefined ? true : t2;
  const ariaLabel = t3 === undefined ? "\u041A\u043E\u0434 \u0438\u0437 SMS" : t3;
  let t4;
  if ($[0] !== autoSubmit || $[1] !== length || $[2] !== onChange || $[3] !== onComplete) {
    t4 = next => {
      onChange(next);
      if (autoSubmit && next.length === length) {
        onComplete?.(next);
      }
    };
    $[0] = autoSubmit;
    $[1] = length;
    $[2] = onChange;
    $[3] = onComplete;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleChange = t4;
  const t5 = ariaInvalid || undefined;
  let t6;
  if ($[5] !== className) {
    t6 = cn("justify-center", className);
    $[5] = className;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== length) {
    t7 = Array.from({
      length
    });
    $[7] = length;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== ariaInvalid || $[10] !== t7) {
    t8 = <InputOTPGroup>{t7.map((_, i) => <InputOTPSlot key={i} index={i} aria-invalid={ariaInvalid || undefined} className="h-12 w-12 text-lg" />)}</InputOTPGroup>;
    $[9] = ariaInvalid;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== ariaLabel || $[13] !== disabled || $[14] !== handleChange || $[15] !== id || $[16] !== length || $[17] !== ref || $[18] !== t5 || $[19] !== t6 || $[20] !== t8 || $[21] !== value) {
    t9 = <InputOTP ref={ref} id={id} maxLength={length} pattern={REGEXP_ONLY_DIGITS} value={value} onChange={handleChange} disabled={disabled} aria-label={ariaLabel} aria-invalid={t5} containerClassName={t6}>{t8}</InputOTP>;
    $[12] = ariaLabel;
    $[13] = disabled;
    $[14] = handleChange;
    $[15] = id;
    $[16] = length;
    $[17] = ref;
    $[18] = t5;
    $[19] = t6;
    $[20] = t8;
    $[21] = value;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
});